// extracted by mini-css-extract-plugin
export default {"name":"Header_name__feHNZ","code":"Header_code__L0ZNw","item":"Header_item__8Ur-Y"};